module.exports = __webpack_public_path__ + "img/flags/KE.bc421f0.png";